import * as actionTypes from './_actionTypes';
import { callApiPopulate } from '../apps/actions';
import axiosInstance from '../../services/axios/axios';
import { WrapImsPacket } from '../utility';

export const addMessage = message => {
	return {
		type: actionTypes.ADD_MESSAGE,
		message: message,
	};
};

export const clearMessage = message => {
	return {
		type: actionTypes.CLEAR_MESSAGE,
		message: message,
	};
};

export const clearMessages = () => {
	return {
		type: actionTypes.CLEAR_MESSAGES,
	};
};

/**
 * Action creator.
 * Dispatches action for filtering `modelUsersFiltered` state.
 *
 * @param {String} value nullable value to filter against.
 * @return {Object} dispatched action.
 */
export const filterModelAfter = value => {
	return {
		type: actionTypes.MODELAFTER_FILTER,
		payload: value,
	};
};

export const modelAfterStart = () => {
	return {
		type: actionTypes.MODELAFTER_START,
	};
};

export const modelAfterSuccess = payload => {
	return {
		type: actionTypes.MODELAFTER_SUCCESS,
		payload: payload,
	};
};

export const modelAfterFail = error => {
	return {
		type: actionTypes.MODELAFTER_FAIL,
		error: error,
	};
};

//  Model after Search Results
export const clearModelAfterResults = () => {
	return {
		type: actionTypes.CLEAR_MODELAFTER_RESULTS,
	};
};

export const modelAfterClear = () => {
	return dispatch => {
		dispatch(clearModelAfterResults());
	};
};

/**
 * Action creator.
 * Performs HTTP Post request to retrieve results of `ModelAfter` search.
 * Successful request requires response with 200 `status` and `responseCode`.
 * Unsuccessful request message(s) not raised as banner(s), first message displayed
 * by `ModelAfter`.
 *
 * @function
 * @param {Object} packet `PersonSearch` search `IMSPacket` object.
 * @returns void
 */
export const modelAfter = packet => {
	return dispatch => {
		dispatch(modelAfterStart());

		// default `validateStatus` config, errors raised on non-2xx response
		axiosInstance
			.post('api/Components/PersonSearch', packet)
			.then(response => {
				switch (response.status) {
					case 200:
						if (response.data) {
							const data = response.data.payload;
							const responseCode = response.data.responseCode;
							const messages = response.data.messages;
							const message =
								Array.isArray(messages) &&
								messages.length > 0 &&
								Object.keys(messages[0]).includes('Value')
									? messages[0].Value
									: 'Error occurred on server';
							switch (responseCode) {
								case 200:
									dispatch(modelAfterSuccess(data));
									clearMessages();
									messages.forEach(message => {
										addMessage(message);
									});
									break;
								default:
									dispatch(modelAfterFail(message));
									break;
							}
						}
						break;
					default:
						dispatch(modelAfterFail('Unexpected server status.'));
						break;
				}
			})
			.catch(error => {
				const message =
					error.response && error.response.data
						? error.response.data.payload
						: error.message;
				dispatch(modelAfterFail(message));
			});
	};
};

export const roleStringStart = () => {
	return {
		type: actionTypes.ROLESTRING_START,
	};
};
export const roleStringSuccess = response => {
	return {
		type: actionTypes.ROLESTRING_SUCCESS,
		response: response,
	};
};
export const roleStringFail = error => {
	return {
		type: actionTypes.ROLESTRING_FAIL,
		error: error,
	};
};

export const roleString = memberInfo => {
	return dispatch => {
		dispatch(roleStringStart());

		const route = memberInfo.populationRoute;
		const payload = {
			memberKey: memberInfo.memberToPopulateKey,
			members: memberInfo.allMembers,
		};

		const imsPacket = WrapImsPacket(payload);

		axiosInstance
			.post('/api/Applications/Population/' + route, imsPacket)
			.then(response => {
				dispatch(roleStringSuccess(response.data));
			})
			.catch(error => {
				dispatch(roleStringFail(error));
			});
	};
};

/**
 * Router action for component PopupIconButton. Action dispatched when optional watched session value changes. Final action route
 * configured via dbo.T_Component.F_Extras. Not an action creator.
 * @param {Object} memberInfo payload from component PopupIconButton action dispatch. Property "route" required in payload.
 * @returns dispatch of final action.
 */
export const PopupSessionChange = memberInfo => {
	switch (memberInfo.route) {
		case 'ADGROUPS_SCREEN':
			return dispatch => {
				dispatch(ADGroupsScreen(memberInfo));
			};
		default:
			break;
	}
	return null;
};

/**
 * PopupIconButton action for application ADGroups. Triggers population actions configured for targetComponentKey. Manipulation is performed
 * on targetComponentKey component within payload model to pass new AD group value for reference in population actions.
 * Used to search for individual AD groups. Action creator.
 * @param {Object} payload payload from component PopupIconButton action dispatch. Required properties in payload: "model" (model of application), "targetComponentKey"
 * (component ID of component to update), "sessionValue" (updated value of watched session variable), "appId" (dbo.T_Application_Master.FI_ID of application)
 * @returns created action.
 */
export const ADGroupsScreen = payload => {
	if (
		Object.keys(payload.model.members).includes(payload.targetComponentKey)
	) {
		let targetComponent = payload.model.members[payload.targetComponentKey];

		// set value of target component
		targetComponent.value = payload.sessionValue;

		// update property 'value' of set action at index '0', if present
		let populationRoute = JSON.parse(
			targetComponent.elementConfig.options[targetComponent.id]
				.PopulationRoute
		);
		if (
			populationRoute &&
			populationRoute.hasOwnProperty('setActions') &&
			populationRoute.setActions !== null
		) {
			populationRoute.setActions[0].value = targetComponent.value;
			populationRoute = JSON.stringify(populationRoute);
			targetComponent.populationRoute = populationRoute;
			targetComponent.elementConfig.options[
				targetComponent.id
			].PopulationRoute = populationRoute;
		}

		payload.model.members[payload.targetComponentKey] = targetComponent;
	}

	return dispatch => {
		dispatch(
			callApiPopulate({
				watchComponentKey: payload.targetComponentKey,
				formToPopulateKey: payload.formIndex,
				allMembers: payload.model.members,
				trackingNumber: payload.model.TrackingNumber,
			})
		);
	};
};

export const updateEsosStart = () => {
	return {
		type: actionTypes.UPDATE_ESOS_START,
	};
};
export const updateEsosFail = () => {
	return {
		type: actionTypes.UPDATE_ESOS_FAIL,
	};
};
export const updateEsosSuccess = esos => {
	return {
		type: actionTypes.UPDATE_ESOS_SUCCESS,
		esos: esos,
	};
};

export const updateEsos = esos => {
	return dispatch => {
		dispatch(updateEsosStart());
		// const route = memberInfo.populationRoute;
		const id = 'esoinfo';
		const payload = { members: esos };

		const imsPacket = WrapImsPacket(payload);

		axiosInstance

			.post('/api/Eso/' + id, imsPacket)
			.then(response => {
				dispatch(updateEsosSuccess(response.data));
			})
			.catch(error => {
				dispatch(updateEsosFail(error));
			});
	};
};

export const toggleDrawer = payload => {
	return {
		type: actionTypes.TOGGLE_DRAWER,
		payload: payload,
	};
};
